import { useTranslation } from "react-i18next";
import { Currency } from "../i18n/Currency";
import { WeightedValue } from "../shared/WeightedValue";
import { WeightedEstimates } from "./general/WeightedEstimates";
import { WeightedAwardEditor } from "./WeightedAwardEditor";

export const WeightedAwardsEditor = ({
  maxAward,
  values,
  currency,
  onChange,
}: {
  maxAward: number;
  values: WeightedValue[];
  currency: Currency;
  onChange: (newValues: WeightedValue[]) => void;
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "weightedAwards" });
  let totalWeight = 0;
  let sum = 0;
  values.forEach((value) => {
    totalWeight += value.weight;
    sum += value.value * value.weight;
  });
  const showWeights = values.length > 1;

  return (
    <WeightedEstimates
      kind="weightedAwards"
      showWeights={showWeights}
      result={
        totalWeight > 0
          ? currency.format((sum / totalWeight) * maxAward)
          : undefined
      }
      onAdd={() => onChange(values.concat({ value: 1, weight: 1 }))}
    >
      {values.map((value, index) => {
        const share = totalWeight > 0 ? value.weight / totalWeight : undefined;
        return (
          <WeightedAwardEditor
            key={"weighted-value-" + index}
            label={t("label.award", { index: index + 1 })}
            value={value.value}
            amount={currency.format(value.value * maxAward)}
            weight={showWeights ? value.weight : undefined}
            share={share}
            onValueChange={(newValue) =>
              onChange(
                values.map((v) =>
                  v === value ? { ...value, value: newValue } : v,
                ),
              )
            }
            onWeightChange={(newWeight) =>
              onChange(
                values.map((v) =>
                  v === value ? { ...value, weight: newWeight } : v,
                ),
              )
            }
            onDelete={
              values.length > 1
                ? () => onChange(values.filter((v) => v !== value))
                : undefined
            }
          />
        );
      })}
    </WeightedEstimates>
  );
};
